import { DialogStateManager } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { Button } from '@plato/ui-legacy/components/ui/button';
import { MicIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { VoiceInputPayload } from '../../analytics/types/analytics-events.ts';
import { RecordingDialog } from './recording-dialog.tsx';

type Props = {
    trackingContext: VoiceInputPayload;
    disabled?: boolean;
    onTranscription: (text: string) => void;
};

export function VoiceRecordingButton({
    trackingContext,
    disabled = false,
    onTranscription,
}: Props): ReactNode {
    const { t } = useTranslation();

    return (
        <Button
            type="button"
            variant="secondary"
            size="sm"
            icon={MicIcon}
            disabled={disabled}
            aria-label={t('voice__start_recording', { ns: 'common' })}
            onClick={() => {
                void DialogStateManager.show(RecordingDialog, {
                    trackingContext,
                    onTranscribed: onTranscription,
                });
            }}
        />
    );
}
